export enum FailureReason {
  FIREWALL_EXCEPTION = 'firewall_exception',
}
